import { fieldTypeForDisplayType } from './fieldTypeMap';

// Address sub-field keys mirror TicketSubcategory::ADDRESS_SUBFIELD_KEYS so the
// generated custom_attributes keys match required_workflow_attribute_keys.
const DEFAULT_ADDRESS_SUBFIELDS = [
  'street',
  'colony',
  'postal_code',
  'city',
  'state',
];

const ADDRESS_SUBFIELD_LABELS = {
  street: 'Calle y número',
  colony: 'Colonia',
  postal_code: 'Código postal',
  city: 'Ciudad',
  state: 'Estado',
};

function attributeFor(ticketAttributes, key) {
  return (ticketAttributes || []).find(attr => attr.attributeKey === key);
}

function addressSubfields(field) {
  const raw = field.sub_fields || field.subFields;
  if (!Array.isArray(raw) || raw.length === 0) return DEFAULT_ADDRESS_SUBFIELDS;
  const normalized = raw
    .map(sf => (typeof sf === 'string' ? sf : sf && (sf.key || sf.id)))
    .map(value => String(value || '').trim())
    .filter(value => DEFAULT_ADDRESS_SUBFIELDS.includes(value));
  return normalized.length ? normalized : DEFAULT_ADDRESS_SUBFIELDS;
}

// Every produced field is tagged source: 'workflow' so the builder can clear
// just these fields when the subcategory changes.
function workflowField(overrides) {
  return {
    field_type: 'text',
    label: '',
    placeholder: '',
    required: false,
    options: [],
    mapped_attribute: '',
    validation_regex: '',
    source: 'workflow',
    ...overrides,
  };
}

export function workflowFieldsToFormFields(workflowConfig, ticketAttributes = []) {
  const fields =
    workflowConfig && Array.isArray(workflowConfig.fields)
      ? workflowConfig.fields
      : [];

  const ordered = [...fields].sort((a, b) => {
    const ao = Number.isFinite(a && a.order) ? a.order : Number.MAX_SAFE_INTEGER;
    const bo = Number.isFinite(b && b.order) ? b.order : Number.MAX_SAFE_INTEGER;
    return ao - bo;
  });

  const result = [];
  ordered.forEach(field => {
    const key = String((field && field.key) || '').trim();
    if (!key) return;

    const required = field.priority === 'required';
    const attribute = attributeFor(ticketAttributes, key);
    const baseLabel =
      field.label || (attribute && attribute.attributeDisplayName) || key;

    if (field.type === 'address') {
      addressSubfields(field).forEach(subfield => {
        const suffix = ADDRESS_SUBFIELD_LABELS[subfield] || subfield;
        result.push(
          workflowField({
            field_type: 'text',
            label: `${baseLabel} – ${suffix}`,
            required,
            mapped_attribute: `ticket.custom.${key}_${subfield}`,
          })
        );
      });
      return;
    }

    const options =
      field.type === 'list' &&
      attribute &&
      Array.isArray(attribute.attributeValues)
        ? [...attribute.attributeValues]
        : [];

    result.push(
      workflowField({
        field_type: fieldTypeForDisplayType(field.type),
        label: baseLabel,
        required,
        options,
        mapped_attribute: `ticket.custom.${key}`,
      })
    );
  });

  return result;
}
